import { useQueryWithUserId } from '@northladder/services';

import { CUSTOMER_SERVICE_API } from '../customerServiceClient';
import { IFetchSummaryPayload } from '../types';

/**
 * This is to track the top brands react query cached data
 */
const TOP_BRANDS_KEY = 'FETCH_INVENTORY_SUMMARY';

/**
 * this hook will call inventory summary customer service api and manage the cached
 * data. and it return the loading, data, error etc.. states reactQuery
 */
export const useInventorySummaryQuery = (payload: IFetchSummaryPayload) => {
  const { by, fromDate, toDate } = payload;

  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [TOP_BRANDS_KEY, by, fromDate, toDate],
    queryFn: () => CUSTOMER_SERVICE_API.fetchInventorySummary(payload),
  });

  return {
    data,
    error,
    isError,
    isPending,
    refetch,
  };
};
